import {
  Component,
  Input,
  HostBinding,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { GasIcon } from './gas-icon.namespace';

const DEFAULT_SIZE = 24;

/**
 * @description Component for icons
 * @description For use just add input 'name' and set icon name
 * @description Icon name you can find in GasIcon namespace
 * @description Inputs:
 * @description name - name of icon, can find in GasIcon namespace
 * @description size - combine of width and height
 * @description color - color of icon
 * @example <gas-icon name="navigations-warning"></gas-icon>
 * @see https://conf.gas20.ru/display/FRON/Icons
 */
@Component({
  selector: 'gas-icon',
  templateUrl: './gas-icon.component.html',
  styleUrls: ['./gas-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconComponent {
  /**
   * @description Icon name you can find in GasIcon namespace
   */
  @Input()
  public name: string | GasIcon.Icons;

  /**
   * @description Combine of width and height
   */
  @Input()
  public set size(size: number) {
    if (size && size !== DEFAULT_SIZE) {
      this.width = size;
      this.height = size;
    } else {
      this.width = DEFAULT_SIZE;
      this.height = DEFAULT_SIZE;
    }
  }

  /**
   * @description Color of icon
   */
  @HostBinding('style.color')
  @Input()
  public color: string;

  /** @deprecated */
  @Input()
  public set iconName(iconName: string | GasIcon.Icons) {
    this.name = iconName;
  }

  /** @deprecated */
  @Input()
  public set variant(variant: string) {
    this.color = variant;
  }

  /** @deprecated */
  @Input()
  public alternativeText: string;

  /** @deprecated */
  @Input()
  public svgClass: string;

  @HostBinding('style.width.px')
  public width: number = DEFAULT_SIZE;

  @HostBinding('style.height.px')
  public height: number = DEFAULT_SIZE;

  constructor(
    public el: ElementRef,
  ) { }

  public get absUrl(): string {
    return window.location.href;
  }
}
